import usa from "./states/USA";
import ca from "./states/CA";

export const states = {
  "CA": ca,
  "USA": usa,
};
